import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import styles from './body-styles.module.css';

export function EmailOutreach() {
    return (
        <div className={styles['email-outreach-container']}>
            <OnboardingBody title={<span>Email outreach</span>}>
                <div>
                    <p>
                        Three types of email outreach support three different types of messages.
                        <br />
                    </p>
                    <BulletedList
                        bullets={[
                            <span key='1'>
                                <b>One-time broadcasts</b> are individual messages sent to make an
                                announcement or inform an audience of something
                            </span>,
                            <span key='2'>
                                <b>Newsletters</b> contain multiple messages that follow a similar
                                theme and are sent on a recurring schedule to stay connected with an
                                audience over time
                            </span>,
                            <span key='3'>
                                <b>Drip sequences</b> are a set of messages that automatically send
                                to an audience at set times or after a specific event
                            </span>,
                        ]}
                    />
                </div>
            </OnboardingBody>
        </div>
    );
}
